import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const No_Parking: React.FC<Props> = ({ fill }) => {
    return (
        <Svg fill={fill} id="_x34_0.no_x5F_parking" height="100%" viewBox="0 0 195 195" width="12pt">
            <Path
                id="icon_34_"
                d="m97.5 21.5c-41.9 0-76 34.1-76 76s34.1 76 76 76 76-34.1 76-76-34.1-76-76-76zm-57.9 76c0-13.9 4.9-26.6 13.1-36.6l15.4 15.4v64.4h18.2v-25.6h11.7c3 0 5.7-.3 8.3-.7l27.9 27.9c-10 8.2-22.7 13.1-36.6 13.1-32 0-58-26-58-57.9zm67.2.4-18.6-18.6h10.2c3.3 0 5.9 1.1 7.8 3.2s2.9 4.9 2.9 8.4c0 3-.8 5.3-2.3 7zm-13.9 3.2h-6.6v-6.6zm49.7 32.6-24.2-24.2c.4-.3.9-.6 1.3-.9 5.3-4.4 7.9-10.3 7.9-17.6 0-5-1.2-9.4-3.7-13.3-2.4-3.9-5.9-6.9-10.3-9.1-4.4-2.1-9.5-3.2-15.3-3.2h-24.1l-12.9-13c9.9-8 22.5-12.8 36.2-12.8 31.9 0 57.9 26 57.9 57.9 0 13.7-4.8 26.3-12.8 36.2z"
            />
        </Svg>
    );
};

export default No_Parking;
